import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';

@Injectable({ providedIn: "root" })
export class GeometryReaderService extends ApiService {
  
  uploadVector(data: FormData) {
    return this.http.post(`${this.geometryReaderUrl}/upload-vector`, data);
  }

  uploadOSMVector(data: FormData) {
    return this.http.post(`${this.geometryReaderUrl}/upload-osmdata`, data);
  }
}